import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import App from "./Pages/Todo";
import RequireAuth from "./Modules/RequireAuth";
import AuthProvider from "react-auth-kit";
import createStore from "react-auth-kit/createStore";
import Login from "./Pages/Login";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import theme from "./Theme/theme";
import { installSessionGuard } from "./sessionGuard";

installSessionGuard();

const store = createStore({
  authName: "_auth",
  authType: "cookie",
  cookieDomain: window.location.hostname,
  cookieSecure: window.location.protocol === "https:",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <AuthProvider store={store}>
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <BrowserRouter>
          <Routes>
            <Route path={"/login"} element={<Login />} />
            <Route
              path={"/*"}
              element={
                <RequireAuth loginPath={"/login"}>
                  <App />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </AuthProvider>
);

export default App;
